/*
 * Zucchiini cart drawer — rediseño CRO 19/08/2026.
 * Acciones ligeras del drawer, todas con cart/add.js o cart/change.js + secciones (morph):
 *   [data-zc-plus1="variantId"]   +1 de la misma variante (barra de pack)
 *   [data-zc-card]                cross-sell: puntos de color, pastillas de talla, "Añadir"
 *   [data-zc-change="lineKey"]    cambiar color/talla de una línea sin salir del drawer
 * Listeners delegados en document (sobreviven a los re-renders). Nunca morph manual: el
 * tema (cart-items-component) reconstruye el HTML desde las secciones devueltas.
 * Medición (22/09/2026): cada uso se anota en el atributo oculto del carrito _zc_upsell
 * (ver trackUpsell), que Shopify copia al pedido y lee el Profit Panel.
 */
(function () {
  if (window.__zcCartInit) return;
  window.__zcCartInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;

  function sectionId() {
    var comp = document.querySelector('cart-items-component[data-section-id]');
    return comp ? comp.getAttribute('data-section-id') : null;
  }

  /* silent: sin secciones ni cart:update (paso intermedio de una operacion de dos pasos). */
  function cartMutate(url, body, silent) {
    var sid = silent ? null : sectionId();
    if (sid) {
      body.sections = sid;
      body.sections_url = window.location.pathname;
    }
    /* Carrera contra un limite de tiempo: una peticion que nunca responde dejaria el
       carrito bloqueado (Horizon pone pointer-events:none mientras actualiza). */
    var corte;
    var limite = new Promise(function (_, reject) {
      corte = setTimeout(function () { reject(new Error('tiempo de espera agotado')); }, 10000);
    });
    var peticion = fetch(ROOT + url, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error((j && (j.description || j.message)) || ('HTTP ' + r.status));
          return j;
        });
      })
      .then(function (res) {
        if (silent) return res;
        var drawer = document.querySelector('cart-drawer-component');
        var hadAutoOpen = drawer && drawer.hasAttribute('auto-open');
        if (hadAutoOpen) drawer.removeAttribute('auto-open');
        try {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { sections: (res && res.sections) || null, source: 'zc-cart' } },
            })
          );
        } finally {
          if (hadAutoOpen) drawer.setAttribute('auto-open', '');
        }
        return res;
      });
    return Promise.race([peticion, limite]).finally(function () { clearTimeout(corte); });
  }

  function money(cents) {
    /* mismo formato que Liquid money_without_trailing_zeros (redondeo a entero, shop.money_format) */
    var host = document.querySelector('[data-zc-money]');
    var fmt = (host && host.getAttribute('data-zc-money')) || '{{amount}}';
    /* Con el envío con umbral activo, las monedas con céntimos reales salen exactas (como zc-money.liquid). */
    var exact = host && (host.getAttribute('data-zc-exact') || '').split(',').indexOf(host.getAttribute('data-zc-cur')) !== -1;
    var kind = (fmt.match(/\{\{\s*([a-z_]+)\s*\}\}/) || [])[1] || 'amount';
    var v = String(Math.round(cents / 100));
    if (exact && kind.indexOf('no_decimals') === -1 && cents % 100 !== 0) {
      v = (cents / 100).toFixed(2);
      if (kind.indexOf('comma') !== -1) v = v.replace('.', ',');
    }
    return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/g, v);
  }

  /* Candado global + vigilante: si una peticion se queda colgada (red, anti-bot), el
     candado se libera solo. Sin esto el drawer queda mudo hasta recargar la pagina. */
  var busyTimer = null;
  function setBusy(btn, on) {
    busy = on;
    if (busyTimer) { clearTimeout(busyTimer); busyTimer = null; }
    if (on) {
      busyTimer = setTimeout(function () {
        busy = false;
        if (btn) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
        console.warn('[zc-cart] peticion colgada: candado liberado por el vigilante');
      }, 12000);
    }
    if (btn) {
      if (on) { btn.setAttribute('disabled', ''); btn.setAttribute('aria-busy', 'true'); }
      else { btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy'); }
    }
  }

  /* ---------- medición de upsells ----------
     Anota "p1:variante" (+1 misma talla), "xs:variante" (Completa el look) o
     "ch:antigua>nueva" (Cambiar) en el atributo _zc_upsell del carrito. Shopify lo copia
     al pedido ("Detalles adicionales"); el cliente no lo ve. Solo tras una acción que ha
     salido bien, en cola (dos usos seguidos no se pisan) y sin tocar la interfaz: si
     falla, se pierde la anotación, nunca la acción. El Function del checkout solo lee
     _fn_pack_test, así que este atributo no cambia precios.
     Cada anotación lleva "@hora" (segundos Unix en base 36): el atributo sobrevive a
     vaciar el carrito y el panel descarta las que llegan al pedido con más de 48 h. */
  var UPSELL_ATTR = '_zc_upsell';
  var upsellQueue = Promise.resolve();
  function trackUpsell(ev) {
    upsellQueue = upsellQueue.then(function () {
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var prev = (cart && cart.attributes && cart.attributes[UPSELL_ATTR]) || '';
          var list = prev ? String(prev).split(' ') : [];
          list.push(ev + '@' + Math.floor(Date.now() / 1000).toString(36));
          var attrs = {};
          attrs[UPSELL_ATTR] = list.slice(-30).join(' ');
          return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: HEADERS, body: JSON.stringify({ attributes: attrs }) });
        });
    }).catch(function (err) { console.warn('[zc-cart] medición', err); });
  }

  function flashError(el, msg) {
    if (!el) return;
    var old = el.innerHTML;            /* innerHTML: el boton lleva <span> dentro */
    el.textContent = msg || 'No se pudo añadir';
    setTimeout(function () { el.innerHTML = old; }, 2500);
  }

  /* ---------- cross-sell: estado por tarjeta ---------- */
  function cardState(card) {
    if (card.__zc) return card.__zc;
    var raw = card.querySelector('[data-zc-variants]');
    var variants = [];
    try { variants = JSON.parse(raw ? raw.textContent : '[]'); } catch (e) {}
    var st = {
      variants: variants,
      colorIdx: Number(card.getAttribute('data-zc-color-idx') || 0),
      sizeIdx: Number(card.getAttribute('data-zc-size-idx') || 0),
      color: card.getAttribute('data-zc-color') || '',
      size: card.getAttribute('data-zc-size') || '',
      mode: card.getAttribute('data-zc-mode') || 'single',
    };
    card.__zc = st;
    return st;
  }
  function vOpt(v, idx) { return idx === 1 ? v.o1 : idx === 2 ? v.o2 : idx === 3 ? v.o3 : null; }
  function findVariant(st) {
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      if (st.colorIdx && vOpt(v, st.colorIdx) !== st.color) continue;
      if (st.sizeIdx && st.size && vOpt(v, st.sizeIdx) !== st.size) continue;
      return v;
    }
    return null;
  }
  function sizesFor(st) {
    var out = [], seen = {};
    st.variants.forEach(function (v) {
      var s = vOpt(v, st.sizeIdx);
      if (s == null || seen[s]) return;
      seen[s] = true;
      var av = st.variants.some(function (w) {
        return w.av && vOpt(w, st.sizeIdx) === s && (!st.colorIdx || vOpt(w, st.colorIdx) === st.color);
      });
      out.push({ s: s, av: av });
    });
    return out;
  }
  function renderPills(card) {
    var st = cardState(card);
    var host = card.querySelector('[data-zc-pills]');
    if (!host || !st.sizeIdx) return;
    host.innerHTML = '';
    sizesFor(st).forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zc-xs__pill' + (o.s === st.size ? ' is-on' : '') + (o.av ? '' : ' is-off');
      b.textContent = o.s;
      b.setAttribute('data-zc-pill', o.s);
      if (!o.av) b.setAttribute('aria-disabled', 'true');
      host.appendChild(b);
    });
  }
  function refreshCard(card) {
    var st = cardState(card);
    var v = findVariant(st);
    var add = card.querySelector('[data-zc-add]');
    var price = card.querySelector('[data-zc-price]');
    var img = card.querySelector('[data-zc-img] img');
    var cname = card.querySelector('[data-zc-color-name]');
    var clbl = card.querySelector('[data-zc-color-lbl]');
    var slbl = card.querySelector('[data-zc-size-lbl]');
    card.setAttribute('data-zc-variant', v ? v.id : '');
    if (add) {
      /* Nunca dejar el boton muerto por falta de talla: se etiqueta "Elegir talla" y
         al pulsarlo abre las pastillas. Solo se deshabilita si esta agotado, y entonces
         lo dice, para que el usuario no crea que la tienda no responde. */
      var needSize = st.sizeIdx && !st.size;
      var verb = add.querySelector('[data-zc-add-verb]');
      var priceEl = add.querySelector('[data-zc-price]');
      if (needSize) {
        add.removeAttribute('disabled');
        if (verb) verb.textContent = 'Elegir talla';
        if (priceEl) priceEl.hidden = true;
      } else if (!v || !v.av) {
        add.setAttribute('disabled', '');
        if (verb) verb.textContent = 'Sin stock';
        if (priceEl) priceEl.hidden = true;
      } else {
        add.removeAttribute('disabled');
        if (verb) verb.textContent = 'Añadir · ';
        if (priceEl) priceEl.hidden = false;
      }
    }
    if (st.dirty && price && v) price.textContent = money(v.p);
    if (st.dirty && img && v && v.img) img.src = v.img;
    if (cname) cname.textContent = st.color;
    if (clbl) clbl.textContent = st.color;
    if (slbl && st.size) slbl.textContent = st.size;
    card.querySelectorAll('[data-zc-dot]').forEach(function (d) {
      d.classList.toggle('is-on', d.getAttribute('data-zc-dot') === st.color);
    });
    renderPills(card);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var plus = t.closest('[data-zc-plus1]');
    if (plus) {
      e.preventDefault();
      if (busy) return;
      var vid = Number(plus.getAttribute('data-zc-plus1'));
      var lineKey = plus.getAttribute('data-zc-plus1-key');
      var lineQty = Number(plus.getAttribute('data-zc-plus1-qty') || 0);
      if (!vid) return;
      setBusy(plus, true);
      /* change.js por key (no add.js): conserva las propiedades de la línea (p. ej. _atclid de
         AnyTrack) y por tanto SUMA en la misma línea en vez de crear una segunda. */
      var req = lineKey && lineQty ? cartMutate('cart/change.js', { id: lineKey, quantity: lineQty + 1 }) : cartMutate('cart/add.js', { items: [{ id: vid, quantity: 1 }] });
      req
        .then(function () { trackUpsell('p1:' + vid); })
        .catch(function (err) { console.error('[zc-cart] +1', err); flashError(plus, 'No disponible'); })
        .finally(function () { setBusy(plus, false); });
      return;
    }

    /* cross-sell: color */
    var dot = t.closest('[data-zc-dot]');
    if (dot) {
      e.preventDefault();
      var card = dot.closest('[data-zc-card]');
      var st = cardState(card);
      st.color = dot.getAttribute('data-zc-dot');
      st.dirty = true;
      /* si la talla elegida no existe en este color, caer a "elegir" */
      if (st.sizeIdx && st.size) {
        var ok = st.variants.some(function (v) { return v.av && vOpt(v, st.colorIdx) === st.color && vOpt(v, st.sizeIdx) === st.size; });
        if (!ok) { st.size = ''; var sz = card.querySelector('[data-zc-sizes]'); if (sz) sz.hidden = false; }
      }
      refreshCard(card);
      return;
    }

    /* cross-sell: abrir/cerrar pastillas */
    var tog = t.closest('[data-zc-toggle-sizes]');
    if (tog) {
      e.preventDefault();
      var card2 = tog.closest('[data-zc-card]');
      var sz2 = card2.querySelector('[data-zc-sizes]');
      if (sz2) { sz2.hidden = !sz2.hidden; if (!sz2.hidden) renderPills(card2); }
      return;
    }

    /* cross-sell: pastilla de talla */
    var pill = t.closest('[data-zc-pill]');
    if (pill && pill.closest('[data-zc-card]')) {
      e.preventDefault();
      if (pill.getAttribute('aria-disabled') === 'true') return;
      var card3 = pill.closest('[data-zc-card]');
      var st3 = cardState(card3);
      st3.size = pill.getAttribute('data-zc-pill');
      st3.dirty = true;
      refreshCard(card3);
      /* en modo "elegir talla", elegir la talla ya añade (2 toques en total) */
      if (st3.mode === 'choose') {
        var addBtn = card3.querySelector('[data-zc-add]');
        if (addBtn && !addBtn.hasAttribute('disabled')) addBtn.click();
      }
      return;
    }

    /* cross-sell: añadir */
    var add = t.closest('[data-zc-add]');
    if (add) {
      e.preventDefault();
      if (busy) return;
      var card4 = add.closest('[data-zc-card]');
      var st4 = cardState(card4);
      /* Sin talla elegida findVariant devolveria la primera del color (XS): abrir las
         pastillas en vez de anadir una talla que el usuario no ha pedido. */
      if (st4.sizeIdx && !st4.size) {
        var szPend = card4.querySelector('[data-zc-sizes]');
        if (szPend) { szPend.hidden = false; renderPills(card4); szPend.scrollIntoView({ block: 'nearest' }); }
        return;
      }
      var v4 = findVariant(st4);
      if (!v4 || !v4.av) {
        var sz4 = card4.querySelector('[data-zc-sizes]');
        if (sz4) { sz4.hidden = false; renderPills(card4); }
        flashError(add, 'Sin stock');
        return;
      }
      setBusy(add, true);
      cartMutate('cart/add.js', { items: [{ id: v4.id, quantity: 1 }] })
        .then(function () { trackUpsell('xs:' + v4.id); })
        .catch(function (err) { console.error('[zc-cart] add', err); flashError(add, 'No disponible'); })
        .finally(function () { setBusy(add, false); });
      return;
    }

    /* cambiar variante de una línea */
    var chg = t.closest('[data-zc-change]');
    if (chg) {
      e.preventDefault();
      openChange(chg);
      return;
    }
    var chgPill = t.closest('[data-zc-chg-pill]');
    if (chgPill) {
      e.preventDefault();
      applyChange(chgPill);
      return;
    }
    var chgClose = t.closest('[data-zc-chg-close]');
    if (chgClose) {
      e.preventDefault();
      var panel = chgClose.closest('[data-zc-chg-panel]');
      if (panel) panel.remove();
      return;
    }
  });

  /* ---------- cambiar color/talla de una línea ---------- */
  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { productCache[handle] = p; return p; });
  }
  function openChange(btn) {
    var row = btn.closest('tr[data-key]');
    if (!row) return;
    var existing = row.querySelector('[data-zc-chg-panel]');
    if (existing) { existing.remove(); return; }
    var handle = btn.getAttribute('data-zc-handle');
    var qty = Number(btn.getAttribute('data-zc-qty') || 1);
    var curColor = btn.getAttribute('data-zc-cur-color') || '';
    var curSize = btn.getAttribute('data-zc-cur-size') || '';
    var host = row.querySelector('.cart-items__details') || row;
    var panel = document.createElement('div');
    panel.className = 'zc-chg';
    panel.setAttribute('data-zc-chg-panel', '');
    panel.innerHTML = '<div class="zc-chg__loading">Cargando opciones…</div>';
    host.appendChild(panel);
    fetchProduct(handle).then(function (p) {
      var colorIdx = 0, sizeIdx = 0;
      p.options.forEach(function (o, i) {
        var n = (o.name || o).toString().toLowerCase();
        if (n === 'color') colorIdx = i + 1;
        if (n === 'talla') sizeIdx = i + 1;
      });
      var state = { color: curColor, size: curSize };
      function opt(v, idx) { return idx === 1 ? v.option1 : idx === 2 ? v.option2 : idx === 3 ? v.option3 : null; }
      function variantFor() {
        return p.variants.find(function (v) {
          return (!colorIdx || opt(v, colorIdx) === state.color) && (!sizeIdx || opt(v, sizeIdx) === state.size);
        });
      }
      function render() {
        var html = '';
        if (colorIdx) {
          var seenC = {};
          html += '<div class="zc-chg__row"><em>Color</em><div class="zc-chg__pills">';
          p.variants.forEach(function (v) {
            var c = opt(v, colorIdx);
            if (seenC[c]) return; seenC[c] = true;
            var av = p.variants.some(function (w) { return w.available && opt(w, colorIdx) === c && (!sizeIdx || !state.size || opt(w, sizeIdx) === state.size); });
            html += '<button type="button" class="zc-xs__pill' + (c === state.color ? ' is-on' : '') + (av ? '' : ' is-off') + '" data-zc-chg-pill data-zc-opt="color" data-zc-val="' + String(c).replace(/"/g, '&quot;') + '">' + c + '</button>';
          });
          html += '</div></div>';
        }
        if (sizeIdx) {
          var seenS = {};
          html += '<div class="zc-chg__row"><em>Talla</em><div class="zc-chg__pills">';
          p.variants.forEach(function (v) {
            var s = opt(v, sizeIdx);
            if (seenS[s]) return; seenS[s] = true;
            var av = p.variants.some(function (w) { return w.available && opt(w, sizeIdx) === s && (!colorIdx || opt(w, colorIdx) === state.color); });
            html += '<button type="button" class="zc-xs__pill' + (s === state.size ? ' is-on' : '') + (av ? '' : ' is-off') + '" data-zc-chg-pill data-zc-opt="size" data-zc-val="' + String(s).replace(/"/g, '&quot;') + '">' + s + '</button>';
          });
          html += '</div></div>';
        }
        html += '<div class="zc-chg__actions"><button type="button" class="zc-chg__apply" data-zc-chg-apply>Aplicar</button><button type="button" class="zc-xs__link" data-zc-chg-close>Cancelar</button></div>';
        panel.innerHTML = html;
        panel.__state = state;
        panel.__apply = function () {
          var v = variantFor();
          var applyBtn = panel.querySelector('[data-zc-chg-apply]');
          if (!v || !v.available) { flashError(applyBtn, 'Agotado'); return; }
          var sameLine = row.getAttribute('data-key');
          if (String(v.id) === String(sameLine).split(':')[0]) { panel.remove(); return; }
          if (busy) return;
          setBusy(applyBtn, true);
          /* Anadir la nueva variante y quitar la antigua. La key de la linea antigua CAMBIA si
             al anadir el pack cruza de escalon (-25 % -> -50 %), asi que se busca de nuevo en
             /cart.js en vez de reutilizar la del render: con la vieja, change.js da 400 y el
             cliente se queda con las dos prendas. */
          var oldKey = row.getAttribute('data-key');
          var oldVid = String(oldKey).split(':')[0];
          cartMutate('cart/add.js', { items: [{ id: v.id, quantity: qty }] }, true)
            .then(function () {
              return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              var lines = (cart.items || []).filter(function (i) { return String(i.variant_id) === oldVid; });
              var line = lines.filter(function (i) { return i.key === oldKey; })[0] ||
                lines.filter(function (i) { return i.quantity === qty; })[0] || lines[0];
              if (!line) return cartMutate('cart/update.js', { updates: {} });
              return cartMutate('cart/change.js', { id: line.key, quantity: 0 });
            })
            .then(function () { trackUpsell('ch:' + oldVid + '>' + v.id); })
            .catch(function (err) { console.error('[zc-cart] change', err); flashError(applyBtn, 'Error'); })
            .finally(function () { setBusy(applyBtn, false); });
        };
        panel.__render = render;
        panel.__setOpt = function (k, val) { state[k] = val; render(); };
      }
      render();
    }).catch(function () { panel.innerHTML = '<div class="zc-chg__loading">No se pudieron cargar las opciones</div>'; });
  }
  function applyChange(pill) {
    var panel = pill.closest('[data-zc-chg-panel]');
    if (!panel || !panel.__setOpt) return;
    if (pill.classList.contains('is-off')) return;
    panel.__setOpt(pill.getAttribute('data-zc-opt'), pill.getAttribute('data-zc-val'));
  }
  document.addEventListener('click', function (e) {
    var ap = e.target && e.target.closest && e.target.closest('[data-zc-chg-apply]');
    if (!ap) return;
    e.preventDefault();
    var panel = ap.closest('[data-zc-chg-panel]');
    if (panel && panel.__apply) panel.__apply();
  });

  /* Al re-renderizar el drawer, inicializar tarjetas (precio/estado del botón). */
  function initCards() {
    document.querySelectorAll('[data-zc-card]').forEach(function (card) {
      if (card.__zcReady) return;
      card.__zcReady = true;
      refreshCard(card);
    });
  }
  var obs = new MutationObserver(function () { initCards(); });
  function start() {
    initCards();
    document.querySelectorAll('cart-items-component').forEach(function (c) { obs.observe(c, { childList: true, subtree: true }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
